import { FC } from 'react';
import { ResponsivePie } from '@nivo/pie';
import classNames from 'classnames';
import styles from './radialProgress.module.scss';
import { RadialProgressProps } from './radialProgressTypes';

const RadialProgress: FC<RadialProgressProps> = (props: RadialProgressProps) => {
    const {
        radius = 4,
        percentage,
        color = '#FB86B6',
        innerRadius = 0.8,
        bgInnerRadius = 0.9,
        bgMargin = 1,
        bgColor = '#C9BAE1',
        cornerRadius = 45,
        number,
        numberSize,
        containerCx
    } = props;

    const endAngle = (360 * percentage) / 100;
    return (
        <div
            className={classNames(styles['radial-container'], containerCx)}
            data-testid="radial"
            style={{ height: `${radius}rem`, width: `${radius}rem` }}
        >
            <div className={styles['bg-radial-container']} style={{ height: `${radius}rem`, width: `${radius}rem` }}>
                <ResponsivePie
                    data={[
                        {
                            id: 'bg',
                            value: 100
                        }
                    ]}
                    enableArcLabels={false}
                    enableArcLinkLabels={false}
                    innerRadius={bgInnerRadius}
                    margin={{ top: bgMargin, right: bgMargin, bottom: bgMargin, left: bgMargin }}
                    colors={[bgColor]}
                />
            </div>

            <ResponsivePie
                fit={false}
                data={[
                    {
                        id: 'progress',
                        value: percentage
                    }
                ]}
                enableArcLabels={false}
                enableArcLinkLabels={false}
                endAngle={endAngle}
                innerRadius={innerRadius}
                cornerRadius={cornerRadius}
                isInteractive={false}
                colors={[color]}
            />

            {number && (
                <div className={styles['inner-number']} style={{ fontSize: `${numberSize}rem` }}>
                    {percentage}
                </div>
            )}
        </div>
    );
};

export default RadialProgress;
